import { FC, Suspense, lazy } from "react";
import { CallerEnum, ProductCardProps } from "./product-card.types";
import { TemplateType } from "@commons-monorepo/index";

const ProductCard1 = lazy(() => import("./skins/product-card-1/product-card-1"));
const ProductCard2 = lazy(() => import("./skins/product-card-2/product-card-2"));
const ProductCard3 = lazy(() => import("./skins/product-card-3/product-card-3"));
const ProductCard4 = lazy(() => import("./skins/product-card-4/product-card-4"));
const ProductCard5 = lazy(() => import("./skins/product-card-5/product-card-5"));
const ProductCard6 = lazy(() => import("./skins/product-card-6/product-card-6"));
const ProductCard7 = lazy(() => import("./skins/product-card-7/product-card-7"));

const ProductCard: FC<ProductCardProps> = ({
  product,
  theme,
  currency,
  locale,
  cartProducts,
  addProduct,
  removeProduct,
  manuallyChangeProduct,
  withTags = true,
  storeMetadata,
  caller = CallerEnum.ProductGrid,
}) => {
  const cardType = theme.template.PRODUCT_CARD;

  if (TemplateType.PRODUCT_CARD_1 === cardType)
    return (
      <Suspense>
        <ProductCard1
          product={product}
          withTags={withTags}
          cartProducts={cartProducts}
          addProduct={addProduct}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          locale={locale}
          currency={currency}
          storeMetadata={storeMetadata}
          caller={caller}
        />
      </Suspense>
    );
  else if (TemplateType.PRODUCT_CARD_2 === cardType)
    return (
      <Suspense>
        <ProductCard2
          product={product}
          withTags={withTags}
          cartProducts={cartProducts}
          addProduct={addProduct}
          theme={theme}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          locale={locale}
          currency={currency}
          storeMetadata={storeMetadata}
          caller={caller}
        />
      </Suspense>
    );
  else if (TemplateType.PRODUCT_CARD_3 === cardType)
    return (
      <Suspense>
        <ProductCard3
          product={product}
          withTags={withTags}
          addProduct={addProduct}
          theme={theme}
          cartProducts={cartProducts}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          locale={locale}
          currency={currency}
          storeMetadata={storeMetadata}
          caller={caller}
        />
      </Suspense>
    );
  else if (TemplateType.PRODUCT_CARD_4 === cardType)
    return (
      <Suspense>
        <ProductCard4
          product={product}
          withTags={withTags}
          addProduct={addProduct}
          theme={theme}
          cartProducts={cartProducts}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          locale={locale}
          currency={currency}
          storeMetadata={storeMetadata}
          caller={caller}
        />
      </Suspense>
    );
  else if (TemplateType.PRODUCT_CARD_5 === cardType)
    return (
      <Suspense>
        <ProductCard5
          product={product}
          withTags={withTags}
          addProduct={addProduct}
          theme={theme}
          cartProducts={cartProducts}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          locale={locale}
          currency={currency}
          storeMetadata={storeMetadata}
          caller={caller}
        />
      </Suspense>
    );
  else if (TemplateType.PRODUCT_CARD_6 === cardType)
    return (
      <Suspense>
        <ProductCard6
          product={product}
          withTags={withTags}
          addProduct={addProduct}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          cartProducts={cartProducts}
          theme={theme}
          locale={locale}
          currency={currency}
          storeMetadata={storeMetadata}
          caller={caller}
        />
      </Suspense>
    );
  else if (TemplateType.PRODUCT_CARD_7 === cardType)
    return (
      <Suspense>
        <ProductCard7
          product={product}
          withTags={withTags}
          addProduct={addProduct}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          cartProducts={cartProducts}
          theme={theme}
          locale={locale}
          currency={currency}
          storeMetadata={storeMetadata}
          caller={caller}
        />
      </Suspense>
    );
  return null;
};

export default ProductCard;
